import React, { useState } from 'react';
import { Card, CardContent, Typography, Box, Button, Alert } from '@mui/material';
import { VolumeUp, PlayArrow } from '@mui/icons-material';
import { LessonStep } from '../../types';
import { playAudio } from '../../../../utils/audioUtils';
import StepNavigation from '../StepNavigation';

interface ListenStepProps {
  step: LessonStep;
  token: string | null;
  onNext: (score?: number) => void;
  onBackToLetters?: () => void;
  lessonId?: string;
}

const ListenStep: React.FC<ListenStepProps> = ({ step, token, onNext, onBackToLetters, lessonId }) => {
  const [hasPlayed, setHasPlayed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayAudio = async () => {
    if (step.content.audio_url) {
      try {
        setIsPlaying(true);
        await playAudio(step.content.audio_url, token);
        setHasPlayed(true);
      } catch (error) {
        console.error('Ошибка воспроизведения аудио:', error);
      } finally {
        setIsPlaying(false);
      }
    }
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {step.title}
        </Typography>
        
        {step.content.instruction && (
          <Typography variant="body1" sx={{ mb: 3 }}>
            {step.content.instruction}
          </Typography>
        )}
        
        {step.content.svg_url && (
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img 
              src={step.content.svg_url} 
              alt={step.title}
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                maxHeight: '400px'
              }}
            />
          </Box>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Button
            variant="contained"
            startIcon={<VolumeUp />}
            onClick={handlePlayAudio}
            disabled={isPlaying}
            size="large"
          >
            {isPlaying ? 'Воспроизводится...' : 'Прослушать звук'}
          </Button>
        </Box>
        
        {hasPlayed && (
          <Alert severity="success" sx={{ mb: 3 }}>
            ✅ Вы прослушали звук буквы
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Button
            variant="contained"
            endIcon={<PlayArrow />}
            onClick={() => onNext()}
            disabled={!hasPlayed}
            size="large"
          >
            Продолжить
          </Button>
        </Box>

        <StepNavigation
          onBackToLetters={onBackToLetters}
          showBackToLetters={true}
        />
      </CardContent>
    </Card>
  );
};

export default ListenStep;
